<li *ngFor="let category of categories?.data.slice(40); let i = index;">
    <a [routerLink]="['/business', getHyphenatedString(category.CategoryName)]" title="{{category.CategoryName}}">{{category.CategoryName}}</a> <span>{{i+1}}</span>
</li>
           